import { ReactComponent as BadgeSvg } from './lib/badge.svg';
import { ReactComponent as CardSvg } from './lib/card.svg';
import { ReactComponent as ContactSupportSvg } from './lib/contact-support.svg';
import { ReactComponent as CopyIconSvg } from './lib/copy.svg';
import { ReactComponent as DeactivatedAccountSvg } from './lib/deactivated-account.svg';
import { ReactComponent as FoldedHandsSvg } from './lib/folded-hands/folded-hands.svg';
import { ReactComponent as GroupsSvg } from './lib/groups/groups.svg';
import { ReactComponent as HandshakeSvg } from './lib/handshake.svg';
import { ReactComponent as HealthAndSafetyOutlinedSvg } from './lib/health-and-safety-outline.svg';
import { ReactComponent as HealthAndSafetySvg } from './lib/health-and-safety.svg';
import { ReactComponent as HigherEdSvg } from './lib/higher-ed.svg';
import { ReactComponent as HomeOutlinedSvg } from './lib/home-outlined.svg';
import { ReactComponent as HomeSvg } from './lib/home.svg';
import { createIconFromSvg } from './lib/icons';
import { ReactComponent as KeySvg } from './lib/key.svg';
import { ReactComponent as LicenseSvg } from './lib/license-icon/license-icon.svg';
import { ReactComponent as MailSentSvg } from './lib/mail-sent.svg';
import { ReactComponent as MedicalServicesSvg } from './lib/medical-services.svg';
import { ReactComponent as NoLicensesSvg } from './lib/no-licenses.svg';
import { ReactComponent as OnboardingSvg } from './lib/onboarding.svg';
import { ReactComponent as OuterLinkSvg } from './lib/outer-link.svg';
import { ReactComponent as PaymentsOutlinedSvg } from './lib/payments-outlined.svg';
import { ReactComponent as PaymentsSvg } from './lib/payments.svg';
import { ReactComponent as PdfUploadSvg } from './lib/pdf-upload.svg';
import { ReactComponent as ScheduleSendSvg } from './lib/schedule-send.svg';
import { ReactComponent as TipsAndUpdatesOutlinedSvg } from './lib/tips-and-updated-outlined.svg';
import { ReactComponent as UpliftUSvg } from './lib/UpLift-U-Logo.svg';
import { ReactComponent as UpliftBetterHelpStackedSvg } from './lib/uplift-betterhelp-stacked.svg';
import { ReactComponent as UpliftBetterHelpStackedWhiteSvg } from './lib/uplift-betterhelp-stacked-white.svg';
import { ReactComponent as UpliftBetterHelpSvg } from './lib/uplift-betterhelp.svg';
import { ReactComponent as VerifiedSvg } from './lib/verified.svg';
import { ReactComponent as VolunteerActivismSvg } from './lib/volunteer-activism.svg';
import { ReactComponent as AccountCircleOffSvg } from './lib/account-circle-off.svg';
import { ReactComponent as LeftPanelCloseSvg } from './lib/left-panel-close.svg';
import { ReactComponent as LeftPanelOpenSvg } from './lib/left-panel-open.svg';

export * from './lib/svg-icon-container/svg-icon-container';
export * from './lib/no-upcoming-sessions-icon/no-upcoming-sessions-icon';
export * from './lib/arrow-up-icon/arrow-up-icon';
export * from './lib/text-icon/text-icon';
export * from './lib/dots-icon/dots-icon';
export * from './lib/cross/cross';
export * from './lib/session-icon/session-icon';
export * from './lib/monetization-on';
export * from './lib/recent-actors-icon';
export * from './lib/avatar-placeholder/avatar-placeholder';
export * from './lib/icons';
export * from './lib/first-icon/first-icon';
export * from './lib/tick-icon/tick-icon';
export * from './lib/screen-and-cross/screen-and-cross';
export * from './lib/license-icon/license-icon.svg';

export { ReactComponent as VisaIcon } from './lib/credit-cards/visa.svg';
export { ReactComponent as DiscoverIcon } from './lib/credit-cards/discover.svg';
export { ReactComponent as AmexIcon } from './lib/credit-cards/amex.svg';
export { ReactComponent as MastercardIcon } from './lib/credit-cards/mastercard.svg';

export * from './lib/new-client-icon/new-client-icon';
export * from './lib/copy-all-outlined/copy-all-outlined';
export * from './lib/tips-outlined/tips-outline';
export * from './lib/log-out/log-out';


export const ContactSupportIcon = createIconFromSvg(ContactSupportSvg);
export const HomeIcon = createIconFromSvg(HomeSvg, '0 0 28 28');
export const HomeOutlinedIcon = createIconFromSvg(HomeOutlinedSvg, '0 0 28 28');
export const CopyIcon = createIconFromSvg(CopyIconSvg);
export const OuterLinkIcon = createIconFromSvg(OuterLinkSvg, '0 0 14 14');
export const PdfUploadIcon = createIconFromSvg(PdfUploadSvg);
export const TipsAndUpdatesOutlinedIcon = createIconFromSvg(TipsAndUpdatesOutlinedSvg);
export const LicenseIcon = createIconFromSvg(LicenseSvg, '0 0 24 24');
export const FoldedHandsIcon = createIconFromSvg(FoldedHandsSvg, '0 0 20 20');
export const GroupsIcon = createIconFromSvg(GroupsSvg, '0 0 20 20');
export const HandshakeIcon = createIconFromSvg(HandshakeSvg, '0 0 24 24');
export const VerifiedIcon = createIconFromSvg(VerifiedSvg, '0 0 24 24');
export const MedicalServicesIcon = createIconFromSvg(MedicalServicesSvg, '0 0 24 24');
export const VolunteerActivismIcon = createIconFromSvg(VolunteerActivismSvg, '0 0 18 18');
export const PaymentsOutlined = createIconFromSvg(PaymentsOutlinedSvg);
export const Payments = createIconFromSvg(PaymentsSvg);
export const HealthAndSafetyOutlined = createIconFromSvg(HealthAndSafetyOutlinedSvg);
export const HealthAndSafety = createIconFromSvg(HealthAndSafetySvg);
export const UpliftUIcon = createIconFromSvg(UpliftUSvg, '0 0 18 18');
export const BadgeIcon = createIconFromSvg(BadgeSvg, '0 0 18 18');
export const Key = createIconFromSvg(KeySvg, '0 0 24 24');
export const Card = createIconFromSvg(CardSvg, '0 0 24 24');
export const HigherEdIcon = createIconFromSvg(HigherEdSvg, '0 0 40 40');
export const ScheduleSend = createIconFromSvg(ScheduleSendSvg);
export const MailSent = createIconFromSvg(MailSentSvg);
export const NoLicenses = createIconFromSvg(NoLicensesSvg);
export const Onboarding = createIconFromSvg(OnboardingSvg);
export const DeactivatedAccount = createIconFromSvg(DeactivatedAccountSvg);
export const AccountCircleOff = createIconFromSvg(AccountCircleOffSvg, '0 0 18 18');
export const LeftPanelClose = createIconFromSvg(LeftPanelCloseSvg);
export const LeftPanelOpen = createIconFromSvg(LeftPanelOpenSvg);

export * from './lib/hourglass/Hourglass';
export * from './lib/no-card/NoCard';
export * from './lib/pending';
export * from './lib/draft';
export * from './lib/prescriptions';


export const UpliftBetterHelpIcon = createIconFromSvg(UpliftBetterHelpSvg, '0 0 116 36', { height: '40px', fontSize: 'unset', width: 'unset' });
export const UpliftBetterHelpStackedIcon = createIconFromSvg(UpliftBetterHelpStackedSvg, '0 0 116 36', { height: '36px', fontSize: 'unset', width: 'unset' });
export const UpliftBetterHelpStackedWhiteIcon = createIconFromSvg(UpliftBetterHelpStackedWhiteSvg, '0 0 116 36', { height: '36px', fontSize: 'unset', width: 'unset', color: 'white' });
